import { mockSales } from "../../constants/mockdata";
const Sales = () => (
    <div className="bg-white shadow-lg rounded-xl">
        <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Order ID</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Customer</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Amount</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                    {mockSales.map((sale) => (
                        <tr key={sale.id} className="hover:bg-gray-50">
                            <td className="px-6 py-4 font-mono text-sm">{sale.id}</td>
                            <td className="px-6 py-4 text-sm font-medium">{sale.user}</td>
                            <td className="px-6 py-4 text-sm font-semibold">£{sale.amount.toFixed(2)}</td>
                            <td className="px-6 py-4"><span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${sale.status === 'Completed' ? 'bg-green-100 text-green-800' : sale.status === 'Processing' ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'}`}>{sale.status}</span></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
);
export default Sales;